import useAxios from "../utils/useAxios";
import { useState, useEffect } from "react";

export function useModes() {
  const [modes, setModes] = useState([]);
  const [loading, setLoading] = useState(true);

  const axiosAPI = useAxios();

  useEffect(() => {
    async function fetchModes() {
      try {
        const response = await axiosAPI.get("/api/dashboard/get-all-modes");
        setModes(response.data.data);
      } catch (error) {
        console.error("Error fetching modes:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchModes();
  }, []);

  return { modes, loading };
}
